"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category Guard Factory
 * @return a Guard that checks if a value is instance of one of the constructor passed
 * @example
 * ```typescript
 *   const isDate = InstanceOf([Date]);
 * ```
 * @example
 * ```typescript
 *   const isBytes = InstanceOf([Buffer, Uint8Array]);
 * ```
 */
const InstanceOf = (constructors) => {
    return (value) => {
        return constructors.some((constructor) => value instanceof constructor);
    };
};
exports.default = InstanceOf;
